import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatSnackBar, MatMenuTrigger } from '@angular/material';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../services/login.service';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';
import { PolicyService } from '../services/policy.service'
import { ReCaptchaV3Service } from 'ng-recaptcha';
declare var $;

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent implements OnInit {
  loginForm: FormGroup;
  activeRouteName: any;
  user: any;
  userType;
  show: boolean;
  pwd: boolean;
  show1: boolean;
  pwd1: boolean;
  show2: boolean;
  pwd2: boolean;
  loading: boolean;
  passwordMismatch;
  oldNewSame;
  error: any;
  submitted: Boolean;
  isDisable = false
  match = false
  isPolicy: Boolean = false
  isAdminPolicy: boolean = false
  policyRouteName

  @ViewChild('clickMenuTrigger', { static: false })
  private readonly clickMenuTrigger: MatMenuTrigger;



  constructor(
    public _EncryptDecryptService: EncryptDecryptService,
    private formBuilder: FormBuilder,
    public _policyService: PolicyService,
    public _snackBar: MatSnackBar,
    public route: Router,
    public dialog: MatDialog,
    public _loginService: LoginService,
    public router: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service,
  ) {

  }

  ngOnInit() {

    this.creatForm()
    $("#password").click(function () {
      $("#password").toggleClass("fa-eye fa-eye-slash");
    });

    $("#cpassword").click(function () {
      $("#cpassword").toggleClass("fa-eye fa-eye-slash");
    });

    $("#opassword").click(function () {
      $("#opassword").toggleClass("fa-eye fa-eye-slash");
    });

  }

  creatForm() {
    this.loginForm = this.formBuilder.group({
      oldPassword: new FormControl('', Validators.required),
      newPassword: new FormControl('', Validators.compose([
        Validators.required,
        this._policyService.patternValidator(/\d/, { hasNumber: true }),
        this._policyService.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        Validators.minLength(8)
      ])),
      confirmPassword: new FormControl('', Validators.required),
    },
      {
        validator: this._policyService.passwordMatchValidatorForReset
      });

    this.router.queryParams.subscribe((params) => {
      console.log("this is params data", params);
      if (params && params.admin) this.isAdminPolicy = params.admin
      if (params && params.password) {
        this.isPolicy = true
        this.loginForm.addControl('email', new FormControl('', Validators.required));
      }

    })

  }



  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  password() {
    this.show1 = !this.show1;
    this.pwd1 = !this.pwd1;
  }

  cpassword() {
    this.show2 = !this.show2;
    this.pwd2 = !this.pwd2;
  }

  opassword() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }

  // onKeyPress(x) {
  //   this.clickMenuTrigger.openMenu();
  //   // console.log("value of password", this.passwords);
  // }
  // closeModel() {
  //   this.clickMenuTrigger.closeMenu();
  // }

  validate(data) {
    console.log("Validating ", data);
    if (!data.oldPassword) return false;
    if (!data.newPassword) return false;
    if (!data.confirmPassword) return false;
    if (data.newPassword !== data.confirmPassword) {
      this.passwordMismatch = true;
      return false;
    }
    this.passwordMismatch = false;
    return true;
  }


  comparePassword(form) {
    console.log(form.value.newPassword == form.value.confirmPassword, this.match);
    if (form.value.newPassword === form.value.confirmPassword) {
      console.log("In true condition");
      this.match = true;
      this.passwordMismatch = false
    } else {
      this.match = false;
      this.passwordMismatch = true
    }

  }

  get f() { return this.loginForm.controls }



  doSubmit() {


    this.submitted = true;

    console.log("Submit ", this.loginForm.value);
    // console.log("Validating = ", this.validate(this.loginForm.value));


    let value = this.loginForm.value;

    if (this.loginForm.valid) {
      this.router.params.subscribe(param => {
        this.activeRouteName = param.user;
      });

      if (this.activeRouteName == 'admin') {
        this.userType = 'admin';
      } else if (this.activeRouteName == 'user') {
        this.userType = 'user';
      }

      if (value.oldPassword == value.newPassword) {
        this.oldNewSame = true;
      } else {
        this.oldNewSame = false;
        this.loading = true;



        let encryptData = {
          oldPassword: this._EncryptDecryptService.encrypt(this.loginForm.value.oldPassword),
          newPassword: this._EncryptDecryptService.encrypt(this.loginForm.value.newPassword),
          confirmPassword: this._EncryptDecryptService.encrypt(this.loginForm.value.confirmPassword)
        }


        this._loginService.resetPassword(encryptData, this.userType).subscribe(data => {
          console.log("Added Successfully", data);
          this.submitted = false;
          this.loading = false;
          // this.ngOnInit();
          // this.loginForm.reset()
          this.error = '';
          this.openSnackBar("Password changed successfully!", "Ok");
          let currentLoggedIn = JSON.parse(localStorage.getItem('currentUser'))
          const user = this._loginService.userRolesValue;


          const learnerDashBoard = '/user/' + currentLoggedIn._id;
          const clientDashboard = '/client/' + currentLoggedIn._id;

          if (user.isAdmin) {
            this.route.navigate(['/dashboard']);
          } else if (user.isTrainer || user.isMp || user.isIQA) {
            this.route.navigate(['/scheduler']);
            // this.route.navigate(['/trainerLogin']);
          } else if (user.isClient) {
            this.route.navigate([clientDashboard]);
          } else if (user.isLearner) {
            this.route.navigate([learnerDashBoard], { queryParams: { job: currentLoggedIn.jobs[0]._id } });
          } else if (user.isStaff) {
            this.route.navigate(['/week-list']);
          }

        }, err => {
          this.loading = false;
          console.log('error while login', err);
          this.error = err.msg
        });
      }
    }

  }


  updatePassword() {
    console.log("this is for password policy update");


    let encryptData = {
      email: this.loginForm.value.email,
      oldPassword: this._EncryptDecryptService.encrypt(this.loginForm.value.oldPassword),
      newPassword: this._EncryptDecryptService.encrypt(this.loginForm.value.newPassword),
      confirmPassword: this._EncryptDecryptService.encrypt(this.loginForm.value.confirmPassword)
    }

    if (this.isAdminPolicy) {
      this.policyRouteName = 'admin'
      this._loginService.updatePasswordPolicyAdmin(encryptData).subscribe((updated) => {
        console.log("password policy update done", updated);
        this.loginUser(updated)
      }, err => {
        console.log("error while update password policy", err);
        this.error = err.error.msg
      })

    } else {

      this.policyRouteName = 'user'
      this._loginService.updatePasswordPolicy(encryptData).subscribe((updated) => {
        console.log("password policy update done", updated);
        this.loginUser(updated)
      }, err => {
        console.log("error while update password policy", err);
        this.error = err.error.msg
      })
    }

  }


  loginUser(data) {

    let obj = {
      email: data.email,
      password: data.password
    }

    this.recaptchaV3Service.execute('importantAction').subscribe((token) => {
      this._loginService.login(obj, this.policyRouteName, token).subscribe(data => {
        const user = this._loginService.userRolesValue;
        this._loginService.sendLoggedInUserToAppUser(data)
        let currentLoggedIn = JSON.parse(localStorage.getItem('currentUser'))
        const learnerDashBoard = '/user/' + data._id;
        const clientDashboard = '/client/' + data._id;
        $(".main").removeAttr('style');

        $(document).ready(function () {
          $(".sidebar").show()
          $("#topnav").show()
          // $(".sidebar").toggleClass('sidebar--Collapse')
        });
        if (user.isAdmin) {
          this.route.navigate(['/dashboard']);
        } else if (user.isTrainer || user.isMp || user.isIQA) {
          console.log("this is data of only staff", data);
          // this.accidentService.displayAccidentTab({ isAccident: data.isAccident })
          this.route.navigate(['/scheduler']);
          // this.route.navigate(['/trainerLogin']);
        } else if (user.isClient) {
          this.route.navigate([clientDashboard]);
        } else if (user.isLearner) {
          if (currentLoggedIn.jobs && currentLoggedIn.jobs[0]._id) {
            this.route.navigate([learnerDashBoard], { queryParams: { job: currentLoggedIn.jobs[0]._id } });
          } else {
            this.route.navigate(['/server-error'])
          }
        } else if (user.isStaff) {
          this.route.navigate(['/week-list']);
        } else if (user.isIncidentUser) {
          this.route.navigate(['/staff/' + data._id])
        }
        else if (user.isOperative) {
          this.route.navigate(['/staff/' + data._id])
        }
      })
    })
  }

}
